import Request from 'api/Request';

export interface MatchScrapedDataRequest {
    job_id: string;
    schools?: string[];
}

export interface MatchScrapedDataResponse {
    results: {
        matched: any[];
        unmatched: any[];
        meet_info: {
            meet_name: string | null;
            date: string | null;
            location: string | null;
        };
    };
}

export default function matchScrapedData(data: MatchScrapedDataRequest) {
    return Request.post<MatchScrapedDataResponse>('/workouts/track-events/match', data);
}
